// extracted by mini-css-extract-plugin
module.exports = {"sportsMenuToggleButton":"_970a509","open":"_1f1fa73"};